import { render, staticRenderFns } from "./PendingTransferInfoView.vue?vue&type=template&id=99a7ba1a&scoped=true&"
import script from "./PendingTransferInfoView.vue?vue&type=script&lang=js&"
export * from "./PendingTransferInfoView.vue?vue&type=script&lang=js&"
import style0 from "./PendingTransferInfoView.vue?vue&type=style&index=0&id=99a7ba1a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a7ba1a",
  null
  
)

export default component.exports